/** @format */
export default {
  onDetail(o: { [x: string]: any }) {
    this.reviewDescriptionOfDialog = '';
    const basicInfo = o['基本信息'];
    const self = this;
    const tempFields = basicInfo.fields;
    basicInfo.fields = tempFields.filter((item: { label: string }) => !item.label.startsWith('审核'));
    let reviewInfo;

    if ('DETAIL' == this.detailDialogType) {
      reviewInfo = {
        fields: tempFields.filter((item: { label: string }) => item.label.startsWith('审核')),
        // .concat({
        //   label: '审核意见',
        //   prop: 'reviewDescription',
        // }),
        data: basicInfo.data
      };
    }

    if ('REVIEW' == this.detailDialogType) {
      reviewInfo = {
        fields: [
          {
            label: '审核意见',
            render(
              c: (
                arg0: string,
                arg1: {
                  attrs: { placeholder: string };
                  style: { 'max-width': string; width: string };
                  on: { change(e: any): void };
                },
                arg2: string
              ) => any
            ) {
              return c(
                'a-textarea',
                {
                  attrs: {
                    placeholder: '请输入审核意见'
                  },
                  style: {
                    'max-width': '250%',
                    width: '250%'
                  },
                  on: {
                    change(e) {
                      self.reviewDescriptionOfDialog = e.target.value;
                    }
                  }
                },
                ''
              );
            }
          }
        ],
        data: basicInfo.data
      };
    }

    self.getImgRenderFunInDetailDialog.call(self, basicInfo);

    return {
      ...o,
      审核信息: reviewInfo
    };
  },
  onSearch(o: any) {
    return {
      parkIds: o.parkIds instanceof Array ? o.parkIds.join(',') : o.parkIds,
      currPage: this.current,
      // plate: o.adapterDataForViewModel.plateHead + o.adapterDataForViewModel.plateTail,
      // userId: '',
      pageSize: this.pageSize,
      liftTypes: o.liftTypes instanceof Array ? o.liftTypes.join(',') : o.liftTypes,
      channelIds: o.channelIds instanceof Array ? o.channelIds.join(',') : o.channelIds
    };
  }
};
